import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Card                                from '@material-ui/core/Card'
import CardActions                         from '@material-ui/core/CardActions'
import CardContent                         from '@material-ui/core/CardContent'
import CardHeader                          from '@material-ui/core/CardHeader'
import MenuItem                            from '@material-ui/core/MenuItem'
import { InjectedFormikProps, withFormik } from 'formik'
import { object }                          from 'yup'

import { CoachingprogramCoachPrices }                          from '../../api'
import { ActionButton, CurrencyTextField, EnhancedTextField }  from '../atoms'
import { genValueMapper, i18nErrorCodes, mapFormikToMuiProps } from '../forms/form-utils'
import { emailSchema, integerMin1 }                            from '../forms/schemas/formatSchemas'

const initValues = {
  price: 0,
  email: '',
}

interface AddCoachPriceProps {
  onAdd: (coachPrice: CoachingprogramCoachPrices) => void
  coaches: string []
}

type Props = InjectedFormikProps<AddCoachPriceProps, typeof initValues>

const AddCoachPrice: React.SFC<Props> = props => {
  const { submitForm, coaches, isValid } = props

  const mapper = mapFormikToMuiProps(props)

  const phrasing = {
    title:   <FormattedMessage id={'generic.addIndividualCoachPrice'} />,
    noItems: <FormattedMessage id={'generic.noItems'} />,
  }

  return (
    <Card>
      <CardHeader title={phrasing.title} />
      <CardContent>
        <EnhancedTextField
          {...mapper('email')}
          fullWidth
          select
          InputLabelProps={{ shrink: true }}
          margin={'dense'}
          error={false}
        >
          {
            coaches.length
              ? coaches.map(coach => (
                <MenuItem key={coach} value={coach}>
                  {coach}
                </MenuItem>
              ))
              : (
                <MenuItem disabled key={'no-items'}>
                  {phrasing.noItems}
                </MenuItem>
              )
          }
        </EnhancedTextField>
        <CurrencyTextField
          {...mapper('price')}
          fullWidth
          margin={'dense'}
          error={false}
        />
      </CardContent>
      <CardActions>
        <ActionButton
          noIcon
          actionType={'add'}
          onClick={submitForm}
          disabled={!isValid}
          color={'primary'}
        />
      </CardActions>
    </Card>
  )
}

export default withFormik<AddCoachPriceProps, typeof initValues>({
  validationSchema: object().shape({
    email: emailSchema.required(i18nErrorCodes.required),
    price: integerMin1.required(i18nErrorCodes.min1),
  }),

  mapPropsToValues: genValueMapper(initValues),

  handleSubmit: (values, bag) => {
    bag.resetForm()
    bag.props.onAdd(values)
  },
})(AddCoachPrice)



// WEBPACK FOOTER //
// ./src/components/organisms/AddCoachPrice.tsx